import { produce } from 'immer'
import { StudyPlanActionTypes, IStudyPlanState, StudyPlanActions } from './types'

const INITIAL_STATE: IStudyPlanState = {
  currentPlanId: null,
  plans: [],
  loading: false,
  error: null,
}

const studyPlanReducer = (state = INITIAL_STATE, action: StudyPlanActions): IStudyPlanState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case StudyPlanActionTypes.SET_CURRENT_PLAN: {
        draft.currentPlanId = action.payload
        break
      }

      case StudyPlanActionTypes.SET_PLANS_LIST: {
        const apiPlanIds = new Set(action.payload.map((p) => p._id))
        // Preserva planos locais que não vieram da API (ex: recém criados)
        const localOnlyPlans = draft.plans.filter((p) => !apiPlanIds.has(p._id))

        // Mescla: planos locais primeiro (mais recentes), depois os da API
        draft.plans = [...localOnlyPlans, ...action.payload]

        // Valida se o currentPlanId ainda existe na lista de planos
        const allPlanIds = new Set(draft.plans.map((p) => p._id))
        const currentPlanExists = draft.currentPlanId && allPlanIds.has(draft.currentPlanId)

        // Se o plano atual não existe mais ou não há plano definido, seleciona o primeiro disponível
        if (!currentPlanExists && draft.plans.length > 0) {
          draft.currentPlanId = draft.plans[0]._id
        } else if (draft.plans.length === 0) {
          draft.currentPlanId = null
        }
        break
      }

      case StudyPlanActionTypes.SET_LOADING: {
        draft.loading = action.payload
        break
      }

      case StudyPlanActionTypes.SET_ERROR: {
        draft.error = action.payload
        draft.loading = false
        break
      }

      case StudyPlanActionTypes.CLEAR_ERROR: {
        draft.error = null
        break
      }

      case StudyPlanActionTypes.REMOVE_PLAN: {
        draft.plans = draft.plans.filter((plan) => plan._id !== action.payload)
        // Se o plano removido era o atual, seleciona outro
        if (draft.currentPlanId === action.payload) {
          draft.currentPlanId = draft.plans.length > 0 ? draft.plans[0]._id : null
        }
        break
      }

      case StudyPlanActionTypes.ADD_PLAN: {
        // Adiciona o novo plano no início da lista
        draft.plans.unshift(action.payload)
        // Define o novo plano como o atual
        draft.currentPlanId = action.payload._id
        break
      }

      case StudyPlanActionTypes.UPDATE_PLAN: {
        // Encontra o índice do plano a ser atualizado
        const index = draft.plans.findIndex((plan) => plan._id === action.payload._id)
        if (index !== -1) {
          // Atualiza o plano mantendo a posição na lista
          draft.plans[index] = action.payload
        }
        break
      }

      case StudyPlanActionTypes.CLEAR_STUDY_PLAN: {
        // Reseta o estado para o inicial (limpa todos os dados do usuário)
        return INITIAL_STATE
      }

      default:
        return draft
    }
  })
}

export default studyPlanReducer
